<template>
  <article class="relative thumbnail">
    <button
      type="button"
      class="content border-2 border-base-30 rounded w-full overflow-hidden"
      :class="{'active': isActive}"
      @click.prevent="$emit('click')"
    >
      <slot name="thumbnail-content" />
    </button>
    <span v-if="showContextMenu" class="context-menu absolute top-1 right-1">
      <ThumbnailContextMenu>
        <template #icon>
          <slot name="context-menu-icon">
            <aha-icon-button
              variant="secondary"
              size="sm"
              class="context-menu-button invisible hover:visible"
            >
              <aha-icon
                class="transform rotate-90"
                name="kebab-menu"
                width="14"
                height="14"
                viewBox="0 0 14 14"
              />
            </aha-icon-button>
          </slot>

        </template>
        <template #items>
          <slot name="context-menu-items" />
        </template>
      </ThumbnailContextMenu>
    </span>
  </article>
</template>
<script>
import ThumbnailContextMenu from './ThumbnailContextMenu.vue'

export default {
  components: {
    ThumbnailContextMenu,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    showContextMenu: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
  },
}
</script>
<style scoped lang="scss">
.thumbnail {
    &:hover, &:focus-within, & > .content:focus-visible  {
        .context-menu .context-menu-button, ~ .context-menu .context-menu-button {
            @apply visible;
        }
    }
}

.content > * {
    width: 100%;
    aspect-ratio: 16 / 9;
}

button.content:hover {
  // Out current tailwind doesn't support outline-color
  // So I need to put the color hex code here to make it work
  border: 2px solid #348EF6;
}

button:focus-visible {
  border: 2px solid #89BEFA;
  outline: none;
}

.active {
  outline: 2px solid #348EF6;
  border: 2px solid white;
}
</style>
